import { render, staticRenderFns } from "./FreeModel.vue?vue&type=template&id=09eddc0c&scoped=true"
import script from "./FreeModel.vue?vue&type=script&lang=js"
export * from "./FreeModel.vue?vue&type=script&lang=js"
import style0 from "./FreeModel.vue?vue&type=style&index=0&id=09eddc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eddc0c",
  null
  
)

export default component.exports